import { reporter } from '~/hooks/useErrorReporter';

/**
 * Reports an error to Sentry and throws it.
 * Use this when an error is unrecoverable and should both be tracked and halt execution.
 *
 * Always call it with `return` at the call site:
 *
 *   return reportAndThrow('Something went wrong');
 *
 * This function never actually returns — it throws internally. However, TypeScript's
 * control flow analysis (CFA) builds its graph syntactically before resolving types,
 * so a standalone call to a `(): never` function is not recognised as a branch
 * terminator. Prefixing with `return` provides the syntactic signal TypeScript needs
 * to narrow types correctly after the call.
 * See: https://github.com/microsoft/TypeScript/issues/12825
 */
export const reportAndThrow = (message: string): never => {
  const error = new Error(message);
  reporter.captureException(error);
  throw error;
};
